import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import Fab from '@material-ui/core/Fab';
import './index.css';
import { PARSER_MODE } from '../../config';

export default class GraphController extends React.Component {
  componentDidMount() {
    // if (!this.props.mode) this.props.changeMode(PARSER_MODE[0].id);
  }
  render() {
    const title = PARSER_MODE.find(({ id }) => id === this.props.mode)
      .description;
    return (
      <form autoComplete="off" className="root-form">
        <FormControl className="form-item">
          <InputLabel htmlFor="diagram-mode">Diagram Mode</InputLabel>
          <Select
            value={this.props.mode}
            onChange={({ target: { value } }) => this.props.changeMode(value)}
            inputProps={{
              name: 'Diagram Mode',
              id: 'diagram-mode',
            }}
          >
            {PARSER_MODE.map(({ id, convert, name }) => (
              <MenuItem key={id} value={id}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl style={{ margin: '0 10px' }}>
          <Tooltip disableFocusListener title={title}>
            <a href={title} style={{ textDecoration: 'none' }} target="_blank">
              <Fab>
                <Icon>sentiment_dissatisfied</Icon>
              </Fab>
            </a>
          </Tooltip>
        </FormControl>
        <FormControl className="form-item">
          <Fab variant="extended" onClick={this.props.onRandom}>
            Random
          </Fab>
        </FormControl>
        <FormControl className="form-item">
          <Fab variant="extended" onClick={this.props.onDownload}>
            Download
          </Fab>
        </FormControl>
        <FormControl className="form-item">
          <Fab
            variant="extended"
            color="primary"
            onClick={this.props.onGenerate}
          >
            Generate
          </Fab>
        </FormControl>
      </form>
    );
  }
}
